import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { EmitterEvents } from "@/hooks/useEmitter";
import useResourcesStore from "@/store/useResourcesStore";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

const GEMS_MINE_REWARD_VALUE = 3;

class GemsMineBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GEMS_MINE;

	public collectGems(): void {
		useResourcesStore().increase(
			ResourceType.GEMS,
			this.gemsProductionWithUpgrade,
			`${this.frameName}: claim gems`,
		);

		this.emitter.emit(EmitterEvents.PhaserDestroyGemsBadge, {
			x: this.x,
			y: this.y,
		});
	}

	public get gemsProductionWithUpgrade(): number {
		return (
			GEMS_MINE_REWARD_VALUE +
			getUpgradeCurrentReplaceValueById(UpgradeIds.gem_rush)
		);
	}
}

export default GemsMineBuildingTileEntity;
